<template>
  <CModal class="modal__footer-empty" size="lg" :close-on-backdrop="false" :show="show" @update:show="closeModal">
    <template #header>
      <div class="d-flex align-items-center">
        <span class="title">Tips & Tricks</span>
      </div>

      <CButtonClose @click="closeModal" />
    </template>

    <div class="subflow">
      <VBlogForm :blog="blog" :show="show" :isCloseModal="isCloseModal" />
    </div>
  </CModal>
</template>

<script>
import VBlogForm from "@/components/Forms/VBlogForm";
import { modalStore } from "@/mixins/modalsMixin";

export default {
  name: "TheBlogModal",

  components: {
    VBlogForm
  },

  data: () => {
    return {
      isCloseModal: false
    }
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    currentUser() {
      return this[authStore.getterTypes.GETTER_USER]
    },
    blog() {
      const blog = this.$store.getters[`${modalStore.moduleName}/${modalStore.getterTypes.GETTER_MODAL_CONTENTS}`];
      return blog
    }
  },
  methods: {
    closeModal() {
      this.isCloseModal = true
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$emit("close");
    },

    onSuccess() {
      this.closeModal();
    }
  }
};
</script>
<style>
.title {
  font-weight: 700;
  font-size: 22px;
  line-height: 22px;
}
</style>